<template>
<div class="flex flex-wrap align-items-center" style="min-height: 300px" v-if="$store.state.ui.contentframeloading">
<ProgressSpinner style="width:50px;height:50px" strokeWidth="4" color="deneme" />
</div>
</template>

<script>
export default {

  name: 'ContentOverlay',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>